export const DFDT_SEARCH_STARTED = 'DFDT_SEARCH_STARTED';
export const DFDT_SEARCH_SUCCESS = 'DFDT_SEARCH_SUCCESS';
export const DFDT_SEARCH_ERROR = 'DFDT_SEARCH_ERROR';